import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload.data.user;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
    loginFail: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = "Login failed";
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { loginSuccess, loginFail, updateUser } = authSlice.actions;
export default authSlice.reducer;
